import { useFormContext } from "react-hook-form";

import { DRIVER_CERTIFICATES_LIST } from "../../../../constants";
import { CertificateField } from "../atoms";
import {
  MainInfoBlockProps,
  DriverFormValues
} from "../DriverDetailsForm.types";

import styles from "../DriverDetailsForm.module.scss";

export const CertificatesBlock = ({
  defaultValues: _defaultValues
}: MainInfoBlockProps) => {
  const { control } = useFormContext<DriverFormValues>();

  return (
    <div className={styles.driverForm__block}>
      {DRIVER_CERTIFICATES_LIST.map((certificate) => (
        <CertificateField
          key={certificate.value}
          control={control}
          certificate={certificate}
        />
      ))}
    </div>
  );
};
